import React, {useEffect, useState} from 'react'
import { AppContent, AppSidebar, AppFooter, AppHeader } from '../components/index'

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import {connect, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {CContainer, CNav, CNavItem} from "@coreui/react";
import {footerActions} from "../redux-store/actions/footer";
import {Loading} from "../components/common";

const DefaultLayout = (props) => {
    console.log("### [DefaultLayout] Component ###");

    const navigate = useNavigate();
    const {user} = useSelector((props) => props.account);

    const [loading, setLoading] = useState(false);
    const [selectedMenu, setSelectedMenu] = useState({
        id: 0,
        component: CNavItem,
        name: '대시보드',
        to: '/main',
        auth: "3"
    });

    useEffect(() => {
        if (user === undefined) {
            navigate("/login");
        }
    }, [])

    const onDeleteMenu = (item) => {
        if (item.id === 0) {
            alert("메인 탭은 삭제 할 수 없습니다.");
            return;
        }
        props.delFooterMenu(item);
    }

    return (
        <>
            {user !== undefined &&
            <CContainer fluid>
                {loading ? <Loading/> : null}
                <AppSidebar setSelectedMenu={setSelectedMenu}/>
                <CNav variant="pills" role="tablist">
                    <div className="wrapper d-flex flex-column min-vh-100">
                        <AppHeader/>

                        <div className="body flex-grow-1 px-3">
                            <AppContent setLoading={setLoading} activeKey={selectedMenu.id} selectedMenu={selectedMenu}/>
                        </div>

                        <AppFooter activeKey={selectedMenu.id} setSelectedMenu={setSelectedMenu} onDeleteMenu={onDeleteMenu}/>
                    </div>
                </CNav>
            </CContainer>
            }
        </>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        delFooterMenu: (menu) => {
            dispatch(footerActions.delFooterMenu(menu));
        }
    };
};

export default connect(null, mapDispatchToProps)(DefaultLayout);
